import { FC, ReactElement } from 'react'
import { Permission } from './permissions.constants'
import withAuthenticatedUser, { WithAuthenticatedUserProps } from './withAuthenticatedUser'

export interface RequiresPermissionsProps {
  permissions: readonly Permission[],
  authorized: ReactElement,
  unauthorized: ReactElement,
  requiresAllPermissions?: boolean,
}

const RequiresPermissions: FC<RequiresPermissionsProps & WithAuthenticatedUserProps> = ({
  authenticatedUser,
  permissions,
  authorized,
  unauthorized,
  requiresAllPermissions = false,
}) => {
  const permissionValidator = requiresAllPermissions
    ? authenticatedUser.hasAllPermissions
    : authenticatedUser.hasAnyPermission
  const canAccessComponent = permissionValidator(permissions)

  if (canAccessComponent) {
    return authorized
  } else {
    return unauthorized
  }
}

export default withAuthenticatedUser(RequiresPermissions)
